import { fromJS } from 'immutable';
import { LOAD_FREELANCERS_SUCCESS, TOGGLE_FREELANCER_VIEW, UPDATE_FREELANCER_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  search: null,
  dataset: [],
  view: {
    isVisible: false,
    freelancerId: null,
  },
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
});

const freelancerTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_FREELANCERS_SUCCESS:
      return state.merge(
        fromJS({
          dataset: action.freelancers.items.map((item) => item.contractorId),
          pagination: {
            totalCount: action.freelancers._meta.totalCount,
            pageCount: action.freelancers._meta.pageCount,
            currentPage: action.freelancers._meta.currentPage,
            perPage: action.freelancers._meta.perPage,
          },
        }),
      );
    case UPDATE_FREELANCER_SUCCESS: {
      const dataset = state.get('dataset');
      return state.set('dataset', dataset.merge(action.freelancer.contractorId));
    }
    case TOGGLE_FREELANCER_VIEW:
      return state.set(
        'view',
        fromJS({
          isVisible: !state.getIn(['view', 'isVisible']),
          freelancerId: action.freelancerId,
        }),
      );
    default:
      return state;
  }
};

export default freelancerTableReducer;
